<script lang="ts">
	import { POINT_THRESHOLDS, type PointThreshold } from '$services/PointsService';
	import { onMount } from 'svelte';
	import { onViewport } from '$services/tracking/IntersectionObserver';
	import PointsProgressTrackingService from '$services/tracking/PointsProgressTrackingService';
	import { Topic } from '$services/tracking/Topic';

	let {
		points, pointThreshold
	}: { points: number, pointThreshold: PointThreshold } = $props();

	let pointsProgressTrackingService: PointsProgressTrackingService;
	let pointsProgressElement: Element;

	const hasMorePointsThanMaxThreshold = POINT_THRESHOLDS.length > 0 && POINT_THRESHOLDS.at(-1)!.points <= points;
	const trackingNextThresholdPoints = hasMorePointsThanMaxThreshold ? 0 : pointThreshold.points;

	const steps = () => {
		if (pointThreshold.points == POINT_THRESHOLDS[1].points) {
			return 2;
		} else if (pointThreshold.points === POINT_THRESHOLDS[2].points) {
			return 3;
		} else {
			return 1;
		}
	};

	const trackView = () => {
		pointsProgressTrackingService.sendProgressBarMiniActionTracking();
	};

	const trackClick = () => {
		pointsProgressTrackingService.sendPointsProgressClickFeatureTracking('clicked', `${trackingNextThresholdPoints}`, pointsProgressElement);
	};

	onMount(() => {
		pointsProgressTrackingService = new PointsProgressTrackingService();
		pointsProgressTrackingService.sendPointsProgressFeatureTracking(
			Topic.AddFeaturesToPageImpression,
			'loaded',
			`${trackingNextThresholdPoints}`,
			pointsProgressElement
		);
	});
</script>

<div
	bind:this={pointsProgressElement}
	on:enterViewport={trackView}
	use:onViewport
	data-testid="points-progress"
	class="points-card oc-mx-100">
	<oc-card-v2 on:click={trackClick} background-color="#ffffff" size="50">
		<a slot="primary-action" href="/myaccount/up" aria-label="Mein UP" tabindex="0"></a>
		<div class="points-card--layout oc-mx-50 oc-my-25">
			<img
				class="picture"
				src="https://i.otto.de/i/otto/up_coin_visual"
				alt=""
				aria-hidden="true"
			>
			{#if !hasMorePointsThanMaxThreshold}
				<div class="point-progress">
					<div
						class="oc-copy-50">{`Sammle noch ${pointThreshold.points - points} Punkte für ${pointThreshold.euros} € Ersparnis`}</div>
					<div class="point-progress--banner">
						<div class="point-progress--banner--bar">
							<oc-progress-bar-v1
								size="100"
								steps="{steps()}"
								value={points}
								max={pointThreshold.points}
								variant="success"
								oc-aria-label={`Punkte-Fortschritt, ${points} von ${pointThreshold.points} Punkten`}></oc-progress-bar-v1>
						</div>
						<div class="point-progress--banner--legend">
							<oc-icon-v1 type="flag-chequered" alt="" aria-hidden="true"></oc-icon-v1>
							<span class="oc-copy-50 oc-copy--bold" aria-label={`Punkte-Ziel ${pointThreshold.points}`}>{pointThreshold.points} Pkt.</span>
						</div>
					</div>
				</div>
			{:else}
				<div class="point-progress__max-points">
					<div class="oc-copy-50 oc-copy--bold">Wow! Du kannst jetzt 15 € sparen!</div>
					<div class="oc-copy-50">Jetzt Punkte einlösen oder fleißig weiter sammeln!</div>
				</div>
			{/if}
		</div>
	</oc-card-v2>
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";
  @use "sass:map";
  @use '../../../node_modules/@otto-ec/otto-components-utils/scss/mixins' as mixins;

  $l-breakpoint: map.get(mixins.$breakpoints, mixins.$breakpoint-l);

  .points-card {
    height: 40px;
    width: auto;

    @media (width >= #{$l-breakpoint}) {
      width: 296px
    }

    &--layout {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: tokens.$oc-semantic-spacing-50;

      .picture {
        width: 32px;
        height: 32px;
      }

      .point-progress {
        display: flex;
        flex-direction: column;
        align-items: start;
        justify-content: center;
        width: 100%;

        &--banner {
          display: flex;
          flex-direction: row;
          align-items: center;
          width: 100%;
          gap: tokens.$oc-semantic-spacing-50;

          &--bar {
            flex-grow: 1;
          }

          &--legend {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: tokens.$oc-semantic-spacing-25;

            oc-icon-v1 {
              width: 12px;
              height: 12px;
            }
          }

          &--max-points {
            display: flex;
            flex-direction: column;
          }
        }
      }
    }
  }
</style>
